import { AchieveLink } from 'components/AchieveLink/AchieveLink'
import { Button } from '@achieve/ascend'
import { Typography } from 'components/Typography'
import { SIGN_IN_ROUTE } from 'constants/navigation'
import { mainProductConfig } from 'constants/mainProductConfig'
import classNames from 'classnames'
import SITE_ENVIRONMENTS from '@/constants/websites'

function SignInLink({
  siteEnv = 'achieve',
  disabledRoutes = [],
  signInLinkUrl,
  signInLinkText,
  event,
  outlined,
  textClassName = '',
  onClick,
  ...restProps
}) {
  if (disabledRoutes.includes(SIGN_IN_ROUTE)) {
    return null
  }

  if (siteEnv === SITE_ENVIRONMENTS.ACHIEVE) {
    signInLinkUrl = `${signInLinkUrl}?utm_source=achieve_sign_in&utm_medium=organic`
  }

  return (
    <AchieveLink
      color="primary"
      href={signInLinkUrl ? signInLinkUrl : SIGN_IN_ROUTE}
      track={{
        ...{
          list_name: 'Header Nav Sign in Link',
          click_id: 'Sign in',
          click_text: `${mainProductConfig[siteEnv || 'achieve']?.['MainProductHyphen']} | Sign in`,
          nav_link_section: 'Header',
          track_event: 'global_header',
          event_action: 'link_click',
          event_type: 'link_click',
        },
        ...event,
      }}
      variant="bodySm"
      {...(onClick
        ? {
            onClickCapture: (e) => {
              e.preventDefault()
              e.stopPropagation()
              onClick(e)
            },
          }
        : {})}
      {...restProps}
    >
      {outlined ? (
        <Button
          color="secondary"
          variant="contained"
          className={classNames('flex flex-row gap-2', {
            'py-[6px]': siteEnv === SITE_ENVIRONMENTS.FDR,
          })}
          size="small"
        >
          <Typography className={`font-extrabold! ${textClassName}`} fontWeight="extrabold">
            {signInLinkText ? signInLinkText : `Sign in`}
          </Typography>
        </Button>
      ) : (
        <Typography className={`font-extrabold! ${textClassName}`} fontWeight="extrabold">
          {signInLinkText ? signInLinkText : `Sign in`}
        </Typography>
      )}
    </AchieveLink>
  )
}

export { SignInLink }
